import angular from 'angular';
import NavPanelComponent from './nav-panel.component';

const NavPanelModule = angular
    .module('control-room.commons.layout.components.nav-panel', [])
    .component('crNavPanel', NavPanelComponent);

export default NavPanelModule;
